

<div class="card">
  <div class="card-content">

    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalCategoriesCount }}</span>
          <span class="stats-card-label">Categories</span>
          <span class="stats-card-sublabel">Service groups</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalEmployeesCount }}</span>
          <span class="stats-card-label">Employees</span>
          <span class="stats-card-sublabel">With history</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalProjectsCount }}</span>
          <span class="stats-card-label">Projects</span>
          <span class="stats-card-sublabel">Total allocations</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ showingCategoriesCount }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After search</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-filter"></i></div>
      </div>
    </div>

    <!-- Scrollable Content Area -->
    <div class="content-scroll-area">

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container loading-container--centered">
      <i class="pi pi-spin pi-spinner loading-spinner-icon"></i>
      <p>Loading employee projects history...</p>
    </div>

    <!-- Category List -->
    <div *ngIf="!loading" class="category-list">
      <div *ngFor="let category of filteredCategoryData" class="category-item">
        <!-- Category Header -->
        <div class="category-header" (click)="toggleCategory(category)">
          <i class="pi mr-2"
             [ngClass]="category.expanded ? 'pi-angle-down' : 'pi-angle-right'"></i>
          <span class="category-name">{{ category.categoryName }}</span>
          <span class="employee-count">({{ category.employees.length }} employee{{ category.employees.length !== 1 ? 's' : '' }})</span>
        </div>

        <!-- Employees List (shown when category is expanded) -->
        <div *ngIf="category.expanded" class="employees-list">
          <div *ngFor="let employee of category.employees" class="employee-item">
            <!-- Employee Header -->
            <div class="employee-header" (click)="toggleEmployee(employee)">
              <i class="pi mr-2"
                 [ngClass]="employee.expanded ? 'pi-angle-down' : 'pi-angle-right'"></i>
              <span class="employee-name">{{ employee.employeeName }}</span>
              <span *ngIf="!employee.isActive" class="former-chip"
                    title="No longer active — shown so past project work stays on the record">Former</span>
              <span class="project-count">({{ employee.projects.length }} project{{ employee.projects.length !== 1 ? 's' : '' }})</span>
            </div>

            <!-- Projects List (shown when employee is expanded) -->
            <div *ngIf="employee.expanded" class="projects-list">
              <div *ngIf="employee.projectEntries.length === 0" class="no-projects">
                No projects found
              </div>
              <div *ngFor="let entry of employee.projectEntries" class="project-item">
                <i class="pi pi-circle-fill project-bullet-icon mr-2"></i>
                <span class="project-name">{{ entry.projectName }}</span>
                <span class="project-duration" title="{{ entry.monthsCount }} month(s) with allocation">{{ entry.durationLabel }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="filteredCategoryData.length === 0" class="empty-state">
        <div class="empty-icon"><i class="pi pi-inbox"></i></div>
        <p class="empty-message">No employee projects history found</p>
        <p class="empty-description">Try changing the search text</p>
      </div>
    </div>

    </div><!-- end content-scroll-area -->
  </div>
</div>
